import React from "react";
import DOMPurify from "dompurify";
import Badge from "react-bootstrap/Badge";
import { formatDateWithTime } from "services/MomentUtils";
import { NotesFilterConstants } from "lookup/NotesFilterConstants";
import { NOTIFY } from "lookup/SwimConstants";

const WfItemNote = ({ note, clipped }) => {
  const sanitizer = DOMPurify.sanitize;

  const showNotifyBadge = note?.type?.toLowerCase() === NOTIFY.toLowerCase();

  return (
    <div className="rm-switch-note-container">
      <span className="rm-switch-note-author">
        {note.type === NotesFilterConstants.SYSTEM
          ? NotesFilterConstants.SYSTEM
          : note.creator}
      </span>
      &nbsp;
      <span className="rm-switch-note-author">
        {showNotifyBadge && note.source}
      </span>
      &nbsp;
      {showNotifyBadge ? (
        <Badge bg="danger">{note.type}</Badge>
      ) : (
        <Badge bg="info">{note.type}</Badge>
      )}
      <Badge bg="info">{formatDateWithTime(note.creationDate)}</Badge>&nbsp;
      {note.new ? <Badge bg="success">New</Badge> : null}
      <div className={`rm-switch-note ${clipped ? "clipped" : ""}`}>
        {<div dangerouslySetInnerHTML={{ __html: sanitizer(note.note) }} />}
      </div>
    </div>
  );
};

export default WfItemNote;
